// extracted by mini-css-extract-plugin
export default {"nav":"SignupNavbar_nav__qfyW0","first":"SignupNavbar_first__qb1V3","second":"SignupNavbar_second__TvC0e"};